import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import SignUp from '../views/SignUp.vue'
import Projects from '../views/Projects.vue'
import ProjectDetails from "../views/ProjectDetails.vue";
import TaskDetails from "../components/TaskDetails.vue";
import PersonalDetails from "../components/PersonalDetails.vue";
import EquipmentDetails from "../components/EquipmentDetails.vue";
import ConsumableDetails from "../components/ConsumableDetails.vue";
import Users from "../views/Users.vue";
import UserDetails from "../views/UserDetails.vue";
import PasswordReset from "../views/PasswordReset.vue";
import ProjectLogs from "../views/ProjectLogs.vue";
import ProjectSummary from "../views/ProjectSummary.vue";
import ProjectTemplates from "../views/ProjectTemplates.vue";
import CategoricalData from "../views/CategoricalData.vue";
import {getLocalUserRole, loadUserRoleFromServer} from "@/mixins/common"

Vue.use(VueRouter)

const routes = [
    {
        path: '*',
        redirect: '/login'
    },
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/sign-up',
        name: 'SignUp',
        component: SignUp
    },
    {
        path: '/reset-password',
        name: 'PasswordReset',
        component: PasswordReset
    },
    {
        path: '/projects',
        name: 'Projects',
        component: Projects,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/projects/:id',
        name: 'ProjectDetails',
        component: ProjectDetails,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/projects/:project_id/tasks/:task_id',
        name: 'TaskDetails',
        component: TaskDetails,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/projects/:project_id/personnel/:personal_id',
        name: 'PersonalDetails',
        component: PersonalDetails,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/projects/:project_id/equipments/:equipment_id',
        name: 'EquipmentDetails',
        component: EquipmentDetails,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/projects/:project_id/consumables/:consumable_id',
        name: 'ConsumableDetails',
        component: ConsumableDetails,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/projects/:project_id/worklogs',
        name: 'ProjectLogs',
        component: ProjectLogs,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/projects/:project_id/summary',
        name: 'ProjectSummary',
        component: ProjectSummary,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users',
        name: 'Users',
        component: Users,
        meta: {
            requiresAuth: true,
            authorizedRoles: [
                'system', 'admin'
            ]
        }
    },
    {
        path: '/users/:id',
        name: 'UserDetails',
        component: UserDetails,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/templates',
        name: 'Templates',
        component: ProjectTemplates,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/categories',
        name: 'CategoricalData',
        component: CategoricalData,
        meta: {
            requiresAuth: true,
            authorizedRoles: [
                'system', 'admin'
            ]
        }
    }
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"))
    let isEmailVerified = false;
    if (currentUser) {
        isEmailVerified = currentUser.emailVerified
    }
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !currentUser) {
        next('login');
    } else if (!requiresAuth && !currentUser) {
        next()
    } else if (!requiresAuth && currentUser && isEmailVerified) {
        next('projects');
    } else if (requiresAuth && currentUser && !isEmailVerified) {
        next('login');
    } else if (!requiresAuth && currentUser && !isEmailVerified) {
        next();
    } else {
        // every other case
        const userRole = getLocalUserRole()
        if (userRole === null) {
            // user role is not loaded from the server, trying to load it again
            loadUserRoleFromServer().then((userRole) => {
                executeRoute(userRole, to, from, next)
            });
        } else {
            executeRoute(userRole, to, from, next)
        }
    }
});

function executeRoute(userRole, to, from, next) {
    const nextPageHasAuthorizedRoles = to.matched.some(record => record.meta.authorizedRoles)
    if (nextPageHasAuthorizedRoles) {
        if (to.meta.authorizedRoles.includes(userRole)) {
            // authorized to see this page
            next();
        } else {
            console.log("!!!USER NOT ALLOWED TO SEE THIS PAGE!!!");
            console.log("REDIRECTING TO HOME");
            next('projects');
        }
    } else {
        next();
    }
}

export default router
